<template>
  <div class="step-topology flex-grow-1 d-flex flex-column min-h-0">
    <p v-if="!readOnly" class="text-body-2 text-medium-emphasis mb-3 flex-shrink-0">
      从左侧拖拽电气元件到画布，通过端口连线组成电站拓扑
    </p>
    <p v-else class="text-body-2 text-medium-emphasis mb-3 flex-shrink-0">
      仅展示拓扑图，可平移与缩放查看；点击「编辑」后可修改元件与连线。
    </p>
    <StationTopologyDesigner
      ref="designerRef"
      class="flex-grow-1 min-h-0"
      :read-only="readOnly"
      :saving="saving"
      @save="onDesignerSave"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import StationTopologyDesigner from './StationTopologyDesigner.vue'

defineProps({
  readOnly: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
})

const emit = defineEmits(['update:draft', 'save'])

const designerRef = ref(null)

function onDesignerSave(data) {
  emit('update:draft', data)
  emit('save', data)
}

defineExpose({
  getTopologyJson: () => designerRef.value?.getTopologyJson?.() ?? null,
  loadTopologyJson: (data) => designerRef.value?.loadTopologyJson?.(data),
})
</script>

<style scoped>
.step-topology {
  min-height: 0;
}
</style>
